import type { Components, Theme } from '@mui/material'

const dialogContent: Components<Omit<Theme, 'components'>>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
    }),
  },
}

export default dialogContent
